var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcArrowBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__c432432432423",
    d: "M16 7L3.83 7 9.42 1.41 8 0 0 8 8 16 9.41 14.59 3.83 9 16 9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b1233432",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c432432432423"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#prefix__b1233432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0z",
    transform: "translate(-17 -17)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcArrowBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-arrow-back.73ef194a.svg";
export { ForwardRef as ReactComponent };